import { render } from "./cn.vue?vue&type=template&id=6437139e&scoped=true"
import script from "./cn.vue?vue&type=script&lang=js"
export * from "./cn.vue?vue&type=script&lang=js"

import "./cn.vue?vue&type=style&index=0&id=6437139e&scoped=true&lang=css"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6437139e"]])

export default __exports__